import { render, staticRenderFns } from "./SavingsAccountTransactionUpdateModal.vue?vue&type=template&id=1638e278"
import script from "./SavingsAccountTransactionUpdateModal.vue?vue&type=script&lang=js"
export * from "./SavingsAccountTransactionUpdateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports